import { MutationRouteBarrelVals } from '@core/api';
import { UrlFromParams } from '@web/hooks/useSlabQuery';

import { pageClientId } from './pageClientId';

// fetch with keepalive is the only request the browser lets outlive an unloading page.
export const releaseQuoteEditLockOnPageHide = (quoteId: string, accessToken: string): void => {
  fetch(
    UrlFromParams({
      pathParams: { id: quoteId },
      queryParams: {},
      urlSplits: MutationRouteBarrelVals['DELETE quote edit lock'].urlSplits,
    }),
    {
      method: 'DELETE',
      keepalive: true,
      headers: { Authorization: `Bearer ${accessToken}`, 'Content-Type': 'application/json' },
      body: JSON.stringify({ clientId: pageClientId }),
    },
  );
};
